// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Product Catalogue API
 * Endpoints for querying product catalogue data including products and their versions.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Product
 */
export interface Product {
  /**
   * The product catalogue version this product belongs to.
   * @type {string}
   * @memberof Product
   */
  version: string;
  /**
   * The date-time from which this product is valid.
   * @type {Date}
   * @memberof Product
   */
  validFrom: Date;
  /**
   * The name of the service.
   * @type {string}
   * @memberof Product
   */
  serviceName: string;
  /**
   * The code identifying the service.
   * @type {string}
   * @memberof Product
   */
  serviceCode: string;
  /**
   * The name of the tier (optional).
   * @type {string}
   * @memberof Product
   */
  tierName?: string | null;
  /**
   * The code identifying the tier (optional).
   * @type {string}
   * @memberof Product
   */
  tierCode?: string | null;
  /**
   * The name of the cloud provider (optional).
   * @type {string}
   * @memberof Product
   */
  cloudProviderName?: string | null;
  /**
   * The region code (optional).
   * @type {string}
   * @memberof Product
   */
  regionCode?: string | null;
  /**
   * The ORB billable metric ID.
   * @type {string}
   * @memberof Product
   */
  orbBillableMetricID: string;
  /**
   * The ORB invoicing key.
   * @type {string}
   * @memberof Product
   */
  orbInvoicingKey: string;
  /**
   * The resource type name.
   * @type {string}
   * @memberof Product
   */
  resourceType: string;
  /**
   * The resource type code.
   * @type {string}
   * @memberof Product
   */
  resourceTypeCode: string;
  /**
   * The base unit price as a rational number string.
   * @type {string}
   * @memberof Product
   */
  baseUnitPrice: string;
  /**
   * The unit of the metric.
   * @type {string}
   * @memberof Product
   */
  metricUnit: string;
  /**
   * The increment value (optional).
   * @type {number}
   * @memberof Product
   */
  incrementValue?: number | null;
  /**
   * The increment unit (optional).
   * @type {string}
   * @memberof Product
   */
  incrementUnit?: string | null;
  /**
   * The increment unit price as a rational number string (optional).
   * @type {string}
   * @memberof Product
   */
  incrementUnitPrice?: string | null;
  /**
   * The increment metric unit (optional).
   * @type {string}
   * @memberof Product
   */
  incrementMetricUnit?: string | null;
  /**
   * A human-readable description of the product (optional).
   * @type {string}
   * @memberof Product
   */
  description?: string | null;
  /**
   * The consumption SKU identifier.
   * @type {string}
   * @memberof Product
   */
  consumptionSKU: string;
  /**
   * The base SKU identifier.
   * @type {string}
   * @memberof Product
   */
  baseSKU: string;
}

/**
 * Check if a given object implements the Product interface.
 */
export function instanceOfProduct(value: object): value is Product {
  if (!('version' in value) || value['version'] === undefined) return false;
  if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
  if (!('serviceName' in value) || value['serviceName'] === undefined)
    return false;
  if (!('serviceCode' in value) || value['serviceCode'] === undefined)
    return false;
  if (
    !('orbBillableMetricID' in value) ||
    value['orbBillableMetricID'] === undefined
  )
    return false;
  if (!('orbInvoicingKey' in value) || value['orbInvoicingKey'] === undefined)
    return false;
  if (!('resourceType' in value) || value['resourceType'] === undefined)
    return false;
  if (!('resourceTypeCode' in value) || value['resourceTypeCode'] === undefined)
    return false;
  if (!('baseUnitPrice' in value) || value['baseUnitPrice'] === undefined)
    return false;
  if (!('metricUnit' in value) || value['metricUnit'] === undefined)
    return false;
  if (!('consumptionSKU' in value) || value['consumptionSKU'] === undefined)
    return false;
  if (!('baseSKU' in value) || value['baseSKU'] === undefined) return false;
  return true;
}

export function ProductFromJSON(json: any): Product {
  return ProductFromJSONTyped(json, false);
}

export function ProductFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Product {
  if (json == null) {
    return json;
  }
  return {
    version: json['version'],
    validFrom: new Date(json['validFrom']),
    serviceName: json['serviceName'],
    serviceCode: json['serviceCode'],
    tierName: json['tierName'] == null ? undefined : json['tierName'],
    tierCode: json['tierCode'] == null ? undefined : json['tierCode'],
    cloudProviderName:
      json['cloudProviderName'] == null ? undefined : json['cloudProviderName'],
    regionCode: json['regionCode'] == null ? undefined : json['regionCode'],
    orbBillableMetricID: json['orbBillableMetricID'],
    orbInvoicingKey: json['orbInvoicingKey'],
    resourceType: json['resourceType'],
    resourceTypeCode: json['resourceTypeCode'],
    baseUnitPrice: json['baseUnitPrice'],
    metricUnit: json['metricUnit'],
    incrementValue:
      json['incrementValue'] == null ? undefined : json['incrementValue'],
    incrementUnit:
      json['incrementUnit'] == null ? undefined : json['incrementUnit'],
    incrementUnitPrice:
      json['incrementUnitPrice'] == null
        ? undefined
        : json['incrementUnitPrice'],
    incrementMetricUnit:
      json['incrementMetricUnit'] == null
        ? undefined
        : json['incrementMetricUnit'],
    description: json['description'] == null ? undefined : json['description'],
    consumptionSKU: json['consumptionSKU'],
    baseSKU: json['baseSKU'],
  };
}

export function ProductToJSON(json: any): Product {
  return ProductToJSONTyped(json, false);
}

export function ProductToJSONTyped(
  value?: Product | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    version: value['version'],
    validFrom: value['validFrom'].toISOString(),
    serviceName: value['serviceName'],
    serviceCode: value['serviceCode'],
    tierName: value['tierName'],
    tierCode: value['tierCode'],
    cloudProviderName: value['cloudProviderName'],
    regionCode: value['regionCode'],
    orbBillableMetricID: value['orbBillableMetricID'],
    orbInvoicingKey: value['orbInvoicingKey'],
    resourceType: value['resourceType'],
    resourceTypeCode: value['resourceTypeCode'],
    baseUnitPrice: value['baseUnitPrice'],
    metricUnit: value['metricUnit'],
    incrementValue: value['incrementValue'],
    incrementUnit: value['incrementUnit'],
    incrementUnitPrice: value['incrementUnitPrice'],
    incrementMetricUnit: value['incrementMetricUnit'],
    description: value['description'],
    consumptionSKU: value['consumptionSKU'],
    baseSKU: value['baseSKU'],
  };
}
